import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import ArticleCard from "@/components/ArticleCard";
import CategoryCard from "@/components/CategoryCard";
import {
  getHotArticles,
  getLatestArticles,
  getRecommendedArticles,
} from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import { hotTopics } from "@/mocks/hotTopics";

export default function Home() {
  const hotArticles = getHotArticles(6);
  const latestArticles = getLatestArticles(6);
  const recommendedArticles = getRecommendedArticles(4);

  useEffect(() => {
    document.title =
      "51吃瓜网今日吃瓜资源 | 51吃瓜网今日大瓜 | 51吃瓜今日吃瓜必吃";
  }, []);

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "51吃瓜网今日吃瓜资源",
    url: "http://yuefenggroup.cn/",
    description:
      "51吃瓜网今日吃瓜资源聚合入口，聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题",
    potentialAction: {
      "@type": "SearchAction",
      target: "http://yuefenggroup.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "51吃瓜网",
    url: "http://yuefenggroup.cn/",
    logo: "http://yuefenggroup.cn/logo.png",
    description:
      "51吃瓜网今日吃瓜资源聚合平台，提供最新爆料、热门黑料、每日大赛等吃瓜资讯",
    sameAs: ["http://yuefenggroup.cn/"],
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "51吃瓜网今日吃瓜资源 | 51吃瓜网今日大瓜",
    url: "http://yuefenggroup.cn/",
    description:
      "聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题",
    isPartOf: {
      "@type": "WebSite",
      name: "51吃瓜网",
      url: "http://yuefenggroup.cn/",
    },
  };

  return (
    <>
      <SEOHead
        title="51吃瓜网今日吃瓜资源 | 51吃瓜网今日大瓜 | 51吃瓜今日吃瓜必吃"
        description="51吃瓜网今日吃瓜资源聚合入口，聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题。按热度整理每日大赛、最新爆料与热门黑料，帮你快速定位今日最值得吃的瓜。"
        keywords="51吃瓜网今日吃瓜资源,51吃瓜网今日大瓜,51吃瓜今日吃瓜必吃,51吃瓜今日大瓜,51吃瓜网今日吃瓜,51吃瓜今日,51吃瓜网今日更新,51吃瓜今日吃瓜入口,51国产吃瓜在线今日吃瓜"
        canonicalUrl="http://yuefenggroup.cn/"
        ogImage="https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20coral%20gradient%20with%20subtle%20newsprint%20texture%20overlay%2C%20dark%20edges%2C%20mysterious%20atmospheric%20light%2C%20cinematic%20editorial%20style%2C%20soft%20glowing%20particles&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        schemaData={[websiteSchema, orgSchema, webPageSchema]}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative h-[420px] md:h-[600px] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                "url(https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20coral%20gradient%20with%20subtle%20newsprint%20texture%20overlay%2C%20dark%20edges%2C%20mysterious%20atmospheric%20light%2C%20cinematic%20editorial%20style%2C%20soft%20glowing%20particles&width=1600&height=900&seq=hero-bg-01&orientation=landscape)",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/50 via-background-950/30 to-background-950/60" />

          <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 max-w-4xl leading-tight">
              51吃瓜网今日吃瓜资源
            </h1>
            <p className="text-base md:text-lg text-background-50/80 max-w-2xl mb-8 leading-relaxed">
              聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题
              <br />
              按热度整理每日大赛、最新爆料与热门黑料
            </p>

            <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-2xl">
              {hotTopics.slice(0, 8).map((topic) => (
                <Link
                  key={topic}
                  to={`/category/jinri-dagua`}
                  className="px-3 py-1.5 md:px-4 md:py-2 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full text-sm text-background-50 hover:bg-primary-500 hover:border-primary-500 transition-all whitespace-nowrap"
                >
                  {topic}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* 今日大瓜 - Hot Articles */}
        <section className="w-full px-4 md:px-8 py-12 md:py-16">
          <div className="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                今日大瓜
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                按热度排序，今天最劲爆的爆料都在这里
              </p>
            </div>
            <Link
              to="/category/jinri-dagua"
              className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hotArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        {/* Categories */}
        <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              吃瓜分类
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              六大核心专题，总有一款瓜适合你
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {categories.map((category) => (
              <CategoryCard key={category.id} category={category} />
            ))}
          </div>
        </section>

        {/* Hot Topics */}
        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="mb-6">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热搜话题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              全网正在讨论的热门关键词
            </p>
          </div>

          <div className="flex flex-wrap gap-2 md:gap-3">
            {hotTopics.map((topic, index) => (
              <Link
                key={topic}
                to={`/category/jinri-dagua`}
                className={`px-3 py-1.5 md:px-4 md:py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  index < 4
                    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                    : index < 8
                      ? "bg-accent-500 text-background-50 hover:bg-accent-600"
                      : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                }`}
              >
                #{topic}
              </Link>
            ))}
          </div>
        </section>

        {/* Two Column Layout: Latest + Recommended */}
        <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
            {/* Latest Articles - 2/3 */}
            <div className="lg:col-span-2">
              <div className="mb-6 flex items-end justify-between">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                    最新爆料
                  </h2>
                  <p className="text-foreground-600 text-sm md:text-base">
                    刚刚更新的吃瓜内容，第一手资讯
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>

            {/* Sidebar: Recommended + Hot Topics */}
            <div className="space-y-8">
              <div>
                <h3 className="text-lg font-bold text-foreground-950 mb-4">
                  主编推荐
                </h3>
                <div className="bg-background-50 rounded-lg border border-background-200 p-4 space-y-2">
                  {recommendedArticles.map((article) => (
                    <ArticleCard
                      key={article.id}
                      article={article}
                      variant="compact"
                    />
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-lg font-bold text-foreground-950 mb-4">
                  热门标签
                </h3>
                <div className="flex flex-wrap gap-2">
                  {[
                    "明星",
                    "婚姻",
                    "爆料",
                    "网红",
                    "税务",
                    "综艺",
                    "黑幕",
                    "投票造假",
                    "直播带货",
                    "潜规则",
                  ].map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 bg-secondary-100 text-secondary-900 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 每日大赛 Banner */}
        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="relative rounded-xl overflow-hidden">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage:
                  "url(https://readdy.ai/api/search-image?query=Competition%20stage%20with%20warm%20golden%20spotlights%20and%20red%20carpet%2C%20dramatic%20theater%20atmosphere%2C%20voting%20theme%20concept%2C%20cinematic%20editorial%20style%20with%20soft%20bokeh%20lights&width=1200&height=400&seq=banner-dasai&orientation=landscape)",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 to-background-950/40" />

            <div className="relative z-10 px-6 md:px-12 py-10 md:py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded-full mb-3">
                  每日大赛
                </span>
                <h2 className="text-xl md:text-2xl font-bold text-background-50 mb-2">
                  今日投票：最离谱塌房理由PK赛
                </h2>
                <p className="text-background-50/70 text-sm md:text-base max-w-lg">
                  从「睡过头」到「不小心」，哪位艺人的塌房理由最离谱？
                  网友票选进行中，快来投出你的一票！
                </p>
              </div>
              <Link
                to="/category/meiri-dasai"
                className="px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
              >
                立即投票 <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
